<template>
  <v-tabs
    v-model="tab"
    class="elevation-2"
    dark
  >
    <v-tabs-slider></v-tabs-slider>
    <v-tab href="#controller-tab">Controller</v-tab>
    <v-tab href="#misc-tab">Misc</v-tab>
    <v-tab href="#communication-tab">Communication</v-tab>
    <v-tab href="#debug-tab">Debug</v-tab>

    <v-tab-item eager value="controller-tab">
      <v-container class="rs-container" fluid fill-height>
        <div ref="container" class="rs-controller" tabindex="0" @keydown="onKeyDown" @keyup="onKeyUp" @mousedown="onMouseDown" @mouseup="onMouseUp" @touchstart="onTouchStart" @touchend="onTouchEnd" @touchcancel="onTouchCancel">
          <Led
            :bridge="bridge"
            width="150" height="150"
            left="490"
            top="20"
            _comment="fix: do not use internal LED since 1.03P60"
            :led="leds[this.leds.length>1?1:0]"
          />
          <div class="rs-background"></div>
          <div class="rs-display">
            <Display ref="display" :type="displayType" :bridge="bridge" :displayBuffer="displayBuffer" />
          </div>
          <v-container class="rs-controls">
            <v-row dense>
              <v-col cols="6" v-for="(button, index) in buttons" :key="`button-${index}`">
                <SensorButton
                  v-model="button.value"
                  :conversion="button.conversion"
                  :name="button.name"
                  :initialValue="button.initialValue"
                  @input="onSensorInput(button, index, $event)"
                />
              </v-col>
                <div class="row" >
                  <div class="column" style="height: 36px;">
                  <canvas ref="overloadLEDCanvas" width="120" height="72" style="margin-bottom: 15px; width: 60px; height: 36px;"></canvas>
                  </div>
                  <div class="column">
                  <v-switch
                      ref="my"
                      v-model="overloadDetect"
                      label="Überlast"
                      @change="overloadDetectChanged"
                      switch-thumb-height='100px'
                      >
                  </v-switch>
                  </div>
                </div>
            </v-row>
            <v-row dense>
              <v-col cols="3" v-for="(output, index) in outputs" :key="`output-${index}`">
                <Output
                  :value="output.value"
                  :conversion="output.conversion"
                  :name="output.name"
                />
              </v-col>
              <v-col cols="6">
                <!-- Output
                  :value="overloadLED.value"
                  :conversion="overloadLED.conversion"
                  :name="overloadLED.name"
                / -->
                 <Output
                   :value="overloadResetPinLed.value"
                   :conversion="overloadResetPinLed.conversion"
                   :name="overloadResetPinLed.name"
                 />

              </v-col>
            </v-row>
          </v-container>
          <!-- <canvas width="857" height="708" style="position: absolute; left: 0; top: 0" ref="debugCanvas"></canvas> -->
        </div>
      </v-container>
    </v-tab-item>
    <v-tab-item eager value="misc-tab">
      <v-container>
        <v-row>
          <v-col>
            <LanguageSelect
              ref="languageSelect"
              title="Regler-Sprache"
              :bridge="bridge"
              :languages="languages"
              :localStoragePrefix="localStoragePrefix"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <LanguageSelect
              title="Screenshot-Sprache"
              ref="screenshotLanguageSelect"
              :languages="languages"
              :localStoragePrefix="localStoragePrefix"
              />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-switch
              v-model="drawBorderAroundScreenshot"
              label="Draw border around screenshot"
            ></v-switch>
            <v-btn
              @click="saveScreenshot()"
            >
              Save screenshot
            </v-btn>
            <v-btn
              @click="saveScreenshots()"
            >
              Save screenshots in all languages
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              @click="reset()"
            >
              Reset
            </v-btn>
            <v-btn
              @click="exportStorage()"
            >
              Export Storage
            </v-btn>
            <v-btn
              @click="$refs.storageFileInput.click()"
            >
              Import Storage &amp; Reset
            </v-btn>
            <v-btn
              @click="eraseStorage()"
            >
              Erase Storage &amp; Reset
            </v-btn>
            <input
              ref="storageFileInput"
              type="file"
              style="display: none"
              @change="onStorageFileInputChanged"
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <SDCard
              :bridge="bridge"
            />

          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <LogPanel :logLines="logLines" />
          </v-col>
          <v-col cols="6">
          </v-col>
        </v-row>
      </v-container>
    </v-tab-item>
    <v-tab-item eager value="communication-tab">
      <CommPanel
        ref="communication"
        :uarts="uarts"
        :bridge="bridge"
        :vbusSpecifications="vbusSpecifications"
      />
    </v-tab-item>
    <v-tab-item eager value="debug-tab">
      <v-container fluid>
        <v-row>
          <v-col cols="6">
            <v-treeview
              :items="debugItems"
              dense
            ></v-treeview>
          </v-col>
          <v-col cols="6">
            <v-btn @click="bridge.start()">Start</v-btn>
            <v-btn @click="bridge.stop()">Stop</v-btn>
            <v-btn @click="generateSupportReport">Generate support report</v-btn>
            <v-textarea
              auto-grow
              dense
              readonly
              :value="supportReportText"
              class="rs-support-report"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-container>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import Display from '@/components/Display';
import SensorButton from '@/components/SensorButton';
import LanguageSelect from '@/components/LanguageSelect';
import SDCard from '@/components/SDCard';
import Output from '@/components/Output';
import LogPanel from '@/components/LogPanel';
import CommPanel from '@/components/communication/CommPanel';
import Led from '@/components/Led';
import Uart from '@/mixins/Uart';
import Bridgeable from '@/mixins/Bridgeable';
import Screenshotable from '@/mixins/Screenshotable';

import state from '@/state';
import { startDownload, readFile } from '@/utils';

export default {
  props: [
    'localStoragePrefix',
    'buttons',
    'outputs',
    'leds',
    'uarts',
    'languages',
    'bridge',
    'vbusSpecifications',
    'displayType',
  ],

  data: () => ({
    logLines: [],
    buttonRefs: null,
    outputRefs: null,
    lastMouseButtonType: 0,
    activeTouches: [],
    tab: null,
    debugItems: [],
    supportReportText: '',
    drawBorderAroundScreenshot: false,
    displayBuffer: null,
    overloadDetectPin: 1,
    overloadDetect: 0,
    overloadResetPin: 0,
    // overloadLED: {
    //   value: {
    //     value: 0,
    //   },
    //   conversion: 'rawDigital',
    //   name: 'OL-Det',
    // },
    overloadResetPinLed: {
      value: {
        value: 0
      },
      conversion: 'rawDigital',
      name: 'OL-Rst',
    }
  }),

  components: {
    Display,
    Led,
    SensorButton,
    Output,
    LanguageSelect,
    SDCard,
    LogPanel,
    CommPanel,
  },

  mixins: [
    Bridgeable,
    Screenshotable,
    Uart,
  ],

  mounted() {
    // const cnv = this.$refs.debugCanvas;
    // const ctx = cnv.getContext('2d');
    // ctx.fillStyle = '#ff000040';
    // ctx.fillRect(210, 485, 114, 36);  // ESC
    // ctx.fillRect(532, 485, 114, 36);  // OK
    // ctx.fillRect(328, 442, 200, 200); // Lightwheel
    // ctx.fillRect(70, 635, 36, 36);    // Func1
    // ctx.fillRect(150, 635, 36, 36);   // Func2
  },

  destroyed() {
  },

  methods: {
    setupAfterReset() {
      // const INPUT_OUTPUT_TYPE_NONE = 0;
      const INPUT_OUTPUT_TYPE_RAW = 1;
      const INPUT_OUTPUT_TYPE_DIGITAL = 2;
      const INPUT_OUTPUT_TYPE_VOLTAGE = 4;
      const INPUT_OUTPUT_TYPE_CURRENT = 16;
      // const INPUT_OUTPUT_TYPE_RESISTOR = 32;
      // const INPUT_OUTPUT_TYPE_COUNTER = 64;
      const INPUT_OUTPUT_TYPE_FREQUENCY = 128;
      const INPUT_OUTPUT_TYPE_DUTYCYCLE = 256;
      // const INPUT_OUTPUT_TYPE_TEMPERATURE = 512;
      // const INPUT_OUTPUT_TYPE_IRRADIATION = 1024;
      // const INPUT_OUTPUT_TYPE_PRESSURE = 2048;
      // const INPUT_OUTPUT_TYPE_FLOW = 4096;
      // const INPUT_OUTPUT_TYPE_PERIODICTIME = 8192;
      // const INPUT_OUTPUT_TYPE_RELATIVE_HUMIDITY = 16384;
      // const INPUT_OUTPUT_TYPE_RADONKONZENTRATION = 32768;
      const INPUT_OUTPUT_TYPE_AGE = 65536;

      // this.bridge.setInputValueForType(0, INPUT_OUTPUT_TYPE_RESISTOR, 0);
      // this.bridge.setInputValueForType(1, INPUT_OUTPUT_TYPE_RESISTOR, 0);
      // this.bridge.setInputValueForType(2, INPUT_OUTPUT_TYPE_RESISTOR, 0);
      // this.bridge.setInputValueForType(3, INPUT_OUTPUT_TYPE_RESISTOR, 0);
      // this.bridge.setInputValueForType(4, INPUT_OUTPUT_TYPE_RESISTOR, 0);
      this.bridge.setInputValueForType(3, INPUT_OUTPUT_TYPE_DIGITAL, 0); // auch Schalter
      this.bridge.setInputValueForType(4, INPUT_OUTPUT_TYPE_DIGITAL, 0); // auch Schalter
      // this.bridge.setInputValueForType(5, INPUT_OUTPUT_TYPE_RESISTOR, 0);
      // this.bridge.setInputValueForType(6, INPUT_OUTPUT_TYPE_RESISTOR, 0);
      // Inputs, die keinen Button haben, initialisieren:
      this.bridge.setInputValueForType(7, INPUT_OUTPUT_TYPE_RAW, 0);
      this.bridge.setInputValueForType(7, INPUT_OUTPUT_TYPE_VOLTAGE, 0);
      this.bridge.setInputValueForType(7, INPUT_OUTPUT_TYPE_CURRENT, 0);
      this.bridge.setInputValueForType(8, INPUT_OUTPUT_TYPE_CURRENT, 0);
      this.bridge.setInputValueForType(9, INPUT_OUTPUT_TYPE_CURRENT, 0);
      this.bridge.setInputValueForType(10, INPUT_OUTPUT_TYPE_FREQUENCY, 0);
      this.bridge.setInputValueForType(10, INPUT_OUTPUT_TYPE_AGE, 0);
      this.bridge.setInputValueForType(11, INPUT_OUTPUT_TYPE_VOLTAGE, 0);
      this.bridge.setInputValueForType(12, INPUT_OUTPUT_TYPE_DUTYCYCLE, 0);
      this.bridge.setInputValueForType(13, INPUT_OUTPUT_TYPE_DIGITAL, 0);
      // this.bridge.setInputValueForType(14, INPUT_OUTPUT_TYPE_VOLTAGE, 0);
      // this.bridge.setInputValueForType(15, INPUT_OUTPUT_TYPE_VOLTAGE, 0);

      let content = Buffer.alloc(1);
      this.bridge.setPlatformConfiguration(0x36740c2c, 15, content);
      this.bridge.setPlatformConfiguration(0x36740c2c, 16, content);
      // RVM_PLATFORM_CONFIGID_BIOSCUSTOMIZATIONID
      this.bridge.setPlatformConfiguration(0x77f4aded, 0, Buffer.from('00000000', 'hex'));
      content.writeUInt8(1);
      this.bridge.setPlatformConfiguration(0x36740c2c, 88, content);
      content.writeUInt8(0);
      this.bridge.setPlatformConfiguration(0x36740c2c, 30, content);

      for (let index = 0; index < this.buttons.length; index++) {
        this.onSensorInput(this.buttons [index], index, this.buttons [index].value);
      }

      this.overloadResetPinLed.value.value = 0;

      this.drawOverloadLED(0);

      this.bridge.on('updatePlatformCopyConfiguration', (configId, index, buffer) => {
        if (configId === 0x36740c2c && index === 30) {
          let outputValue = null;

          if (buffer.length === 1) {
            outputValue = buffer.readInt8(0);
          } else if (buffer.length === 2) {
            outputValue = buffer.readInt16LE(0);
          } else if (buffer.length === 4) {
            outputValue = buffer.readInt32LE(0);
          }
          if (outputValue != null) {

            // console.log("outputValue:", outputValue, "this.overloadDetect:", this.overloadDetect);

            if (outputValue === 1)
            {
              this.overloadResetPinLed.value = { value: 1};
              setTimeout(() => {this.overloadResetPinLed.value = {value: 0}; } , 800);

            }
            // this.overloadResetPinLed.value = { value: outputValue ? 1 : 0};

            if (1===outputValue && false===this.overloadDetect )
            {
              this.drawOverloadLED(0);

              // this.overloadLED.value = { value: 0 };

              global.console.log(this.overloadLED);
              global.console.log("OL: RESET_PIN=HI  | RESET DETECT_PIN to HI");
              let content = Buffer.alloc(1);
              this.overloadDetectPin = 1;
              content.writeUInt8(this.overloadDetectPin);
              this.bridge.setPlatformConfiguration(0x36740c2c, 88, content);
            }
          }
        }
      });
    },

    preparePlatform() {
      this.debugItems = this.bridge.debugProbes;

      this.setupAfterReset();

      this.$refs.container.focus();

      this.buttonRefs = this.buttons.reduce((memo, button) => {
        if (button.ref) {
          memo [button.ref] = button;
        }
        return memo;
      }, {});

      this.outputRefs = this.outputs.reduce((memo, output) => {
        if (output.ref) {
          memo [output.ref] = output;
        }
        return memo;
      }, {});

      this.initializeCommunication();

      this.$emit('initialized');
    },

    onKeyDown(ev) {
      this.onKeyEvent(ev, true);
    },

    onKeyUp(ev) {
      this.onKeyEvent(ev, false);
    },

    onKeyEvent(ev, state) {
      let buttonType;
      switch (ev.key) {
      case 'Enter':
        buttonType = 5;
        break;
      case 'Backspace':
        buttonType = 6;
        break;
      case 'ArrowRight':
      case '.':
        buttonType = 2;
        break;
      case 'ArrowLeft':
      case ',':
        buttonType = 1;
        break;
      default:
        // console.log(ev.key);
        buttonType = 0;
        break;
      }

      // console.log(buttonType, state);

      if (buttonType > 0) {
        ev.preventDefault();
        ev.stopPropagation();

        this.bridge.setButtonState(buttonType, state);
      }
    },

    getButtonTypeByCoord(x, y) {
      const coords = {
        x,
        y,
      };

      // console.log(coords);

      function checkCoords(x, y, w, h) {
        let result;
        if (coords.x < x) {
          result = false;
        } else if (coords.x >= (x + w)) {
          result = false;
        } else if (coords.y < y) {
          result = false;
        } else if (coords.y >= (y + h)) {
          result = false;
        } else {
          result = true;
        }
        return result;
      }

      let buttonType;
      if (checkCoords(195, 393, 64, 64)) {
        buttonType = 1;  // LEFT
      } else if (checkCoords(316, 378, 90, 90)) {
        buttonType = 5;  // CENTER
      } else if (checkCoords(459, 393, 64, 64)) {
        buttonType = 2;  // RIGHT
      }

      return buttonType;
    },

    onMouseDown(ev) {
      if (this.lastMouseButtonType) {
        this.onMouseEvent(ev, false);

        this.lastMouseButtonType = 0;
      }

      const buttonType = this.getButtonTypeByCoord(ev.offsetX, ev.offsetY);
      this.lastMouseButtonType = buttonType;

      this.onMouseEvent(ev, true);
    },

    onMouseUp(ev) {
      this.onMouseEvent(ev, false);

      this.lastMouseButtonType = 0;
    },

    onMouseEvent(ev, state) {
      const buttonType = this.lastMouseButtonType;

      if (buttonType > 0) {
        ev.preventDefault();
        ev.stopPropagation();

        this.bridge.setButtonState(buttonType, state);
      }
    },

    onTouchStart(ev) {
      this.onTouchEvent(ev, true);
    },

    onTouchEnd(ev) {
      this.onTouchEvent(ev, false);
    },

    onTouchCancel(ev) {
      this.onTouchEvent(ev, false);
    },

    onTouchEvent(ev) {
      let stopEvent = false;

      const activeTouches = [];
      for (let index = 0; index < ev.touches.length; index++) {
        const touch = ev.touches.item(index);

        let touchInfo = this.activeTouches.find(info => info.identifier === touch.identifier);
        if (!touchInfo) {
          const rect = touch.target.getBoundingClientRect();

          const x = touch.clientX - rect.x;
          const y = touch.clientY - rect.y;


          const buttonType = this.getButtonTypeByCoord(x, y);

          if (buttonType) {
            this.bridge.setButtonState(buttonType, true);
            stopEvent = true;
          }

          touchInfo = {
            identifier: touch.identifier,
            buttonType,
            x,
            y,
          };
        }

        activeTouches.push(touchInfo);
      }

      for (const touchInfo of this.activeTouches) {
        if (!activeTouches.includes(touchInfo)) {
          if (touchInfo.buttonType) {
            this.bridge.setButtonState(touchInfo.buttonType, false);
            stopEvent = true;
          }
        }
      }

      if (stopEvent) {
        ev.preventDefault();
        ev.stopPropagation();
      }

      this.activeTouches = activeTouches;
    },

    drawOverloadLED(val) {
      let ctx = this.$refs['overloadLEDCanvas'].getContext('2d');

      ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

      ctx.save();
      ctx.scale(2, 2);

      ctx.clearRect(0, 0, 36, 36);

      ctx.beginPath();
      ctx.arc(18, 18, 16, 0, 2 * Math.PI);
      ctx.closePath();

      ctx.fillStyle = val ? 'rgb(220, 0, 0)' : 'rgb(64, 0, 0)';
      ctx.fill();

      ctx.strokeStyle = 'black';
      ctx.stroke();

      ctx.fillStyle = 'black';

      ctx.font = '500 14px "Roboto", sans-serif';
      ctx.fillText("ÜL", 40, 14);

      ctx.font = '500 14px "Roboto", sans-serif';
      ctx.fillText(val, 40, 32);

      ctx.restore();

    },

    overloadDetectChanged() {
      let content = Buffer.alloc(1);

      this.overloadDetectPin = !this.overloadDetect;
      global.console.log("overloadDetectChanged()", this.overloadDetectPin, this.overloadLED);

      if (false===this.overloadDetectPin)
      {
        this.drawOverloadLED(1);

        // this.$refs.my.$emit('background-color','red');
        this.$refs.my.$emit.backgroundcolor = 'red';

        // this.overloadLED.value = { value : 1};

        // console.log( this.overloadLED.value.value );


        global.console.log("OL-DETECT (OL_DETECT_PIN=LO)");
        content.writeUInt8(this.overloadDetectPin);
        this.bridge.setPlatformConfiguration(0x36740c2c, 88, content);
      }
    },

    handleInterval() {
      if (this.bridge.isDisplayInvalidated()) {
        this.displayBuffer = this.bridge.getDisplayBuffer().slice();
      }

      if (this.bridge.isLedInvalidated()) {
          const ColorShiftOff = 0;
          const ColorShiftRed = 8;
          const ColorShiftGreen = 12;
          const ColorShiftOrange = 16;

          for (let index = 0; index < this.leds.length; index++) {
            if (!(this.leds [index])) { continue; }
            const state = this.bridge.getLedStaticState(index);

            this.leds [index].state = state;
            this.leds [index].TimerColor0 = ((state >> ColorShiftOff) & 15) * 25;
            this.leds [index].TimerColor1 = ((state >> ColorShiftRed) & 15) * 25;
            this.leds [index].TimerColor2 = ((state >> ColorShiftGreen) & 15) * 25;
            this.leds [index].TimerColor3 = ((state >> ColorShiftOrange) & 15) * 25;
          }
      }

      if (this.bridge.isOutputInvalidated()) {
        for (let index = 0; index < 19; index++) {
          if (!this.outputs [index]) {
            continue;
          }
          const value = this.bridge.getOutputValueAndType(index);
          this.outputs [index].value = value;
        }
      }
      // RVM_PLATFORM_CONFIGID_BOARDCUSTOMGPIO 0x36740c2c
      // Index 15 = OnionGpio15, 16 = OnionGpio16
      this.bridge.copyPlatformConfiguration(0x36740c2c, 15);
      this.bridge.copyPlatformConfiguration(0x36740c2c, 30);
    },

    onSensorInput(button, fallbackIndex, value) {
      // Error.stackTraceLimit = Infinity;
      // console.log(index, button.name, button.value, value, new Error().stack);
      const index = button.platformIndex == null ? fallbackIndex : button.platformIndex;
      if (!this.bridge || !value) {
        // nop
      } else {
        this.bridge.setInputValueForType(index, value.type, value.value);
      }
    },

    async generateSupportReport() {
      const jsonString = JSON.stringify(this.debugItems);
      const jsonBuffer = Buffer.from(jsonString);
      const b64String = jsonBuffer.toString('base64');
      const lines = b64String.replace(/(.{76})/g, '$1\n').trim();
      const report = `----BEGIN WASI CONTROLLER TRAINER SUPPORT REPORT----\n${lines}\n----END WASI CONTROLLER TRAINER SUPPORT REPORT----\n`;
      this.supportReportText = report;

      await navigator.clipboard.writeText(report);
    },

    // reset() {
    //   this.bridge.stop();

    //   const {
    //     storage,
    //   } = this;
    //   const storageTotalCapacity = 4 * 1024 * 1024;

    //   // this.initializeBridge({
    //   //   storage,
    //   // });
    //   this.bridge.initialize({storage, storageTotalCapacity});
    // },

    exportStorage() {
      startDownload(`storage-${Date.now()}.cbor`, 'application/octet-stream', this.storage);
    },

    onStorageFileInputChanged() {
      state.runAsync(async () => {
        const buffer = await readFile(this.$refs.storageFileInput);

        this.storage = buffer;
        this.reset();
      });
    },

    eraseStorage() {
      this.storage = null;

      const storageLsKey = `${this.localStoragePrefix}Storage`;
      // console.log(`remove storage item ${storageLsKey}`)
      localStorage.removeItem(storageLsKey);

      this.reset();
    },
  },
};
</script>

<style scoped>
.rs-container {
  padding: 0;
}

.rs-controller {
  width: 1400px;
  height: 708px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
}

.rs-background {
  width: 724px;
  height: 708px;
  position: absolute;
  background: url('/DevicePv_Neutral_LED.png');
  background-size: 724px 1024px;
  background-position: center bottom -30px;
}

.rs-display {
  position: absolute;
  width: 386px;
  height: 193px;
  left: 166px;
  top: 116px;
}

.rs-controls {
  position: absolute;
  left: 860px;
  top: 0px;
  width: 400px;
  height: 708px;
  max-width: 400px;
}

.rs-support-report {
  font-family: 'Courier New', Courier, monospace;
  font-size: 10px;
}

.rs-support-report >>> textarea {
  line-height: 12px;
}



.column {
 float: left;
 width: 40%;
vertical-align: middle;
  text-align: center;
}

.row:after {
 content: "";
 display: table;
 clear: both;
}

</style>
